import '../style/components/LoadingPlaceholder.css'

type Variant = 'all' | 'today' | 'week'

type LoadingPlaceholderProps = {
  variant: Variant
}

function LoadingPlaceholder({ variant }: LoadingPlaceholderProps) {
  if (variant === 'today') {
    return (
      <div className="placeholder-shell placeholder-card shimmer">
        <div className="today-card">
          <div className="today-header">
            <div className="pill-row">
              <span className="pill pill-strong shimmer-block" />
              <span className="pill shimmer-block" />
              <span className="pill shimmer-block" />
            </div>
            <div className="title-line shimmer-block" />
            <div className="subtitle-line shimmer-block" />
          </div>
          <div className="paragraph-block">
            <div className="line long shimmer-block" />
            <div className="line shimmer-block" />
            <div className="line short shimmer-block" />
          </div>
        </div>
      </div>
    )
  }

  if (variant === 'week') {
    return (
      <div className="placeholder-shell placeholder-plain week-stack">
        {[1, 2, 3].map((item) => (
          <div key={item} className="list-card shimmer-block" />
        ))}
      </div>
    )
  }

  return (
    <div className="placeholder-shell placeholder-plain">
      <div className="tiles-grid">
        {Array.from({ length: 8 }).map((_, index) => (
          <div key={index} className="tile shimmer-block" />
        ))}
      </div>
    </div>
  )
}

export default LoadingPlaceholder
